import { Condition, ConditionData, ConditionHelper, ConditionProviders } from "@app/rule/model/conditions/condition";
import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";

export interface PropertyChangeCondition extends Condition {
    name: string;
    conditionId: string;
    conditionType: string;
    uid: string;
    property: string;
    constraint: string;
    deviceClass: string;
    comparisonOperation: string;
    controlPointFriendlyName?: string;
    serviceName?: string;
    controlPointId?: string;
    friendlyName?: string;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface PropertyChangeConditionData extends ConditionData {
    name: string;
    condition_id: string;
    condition_type: string;
    uid: string;
    property: string;
    constraint: string;
    device_class: string;
    comparison_operation: string;
    friendlyName?: string;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class PropertyChangeConditionHelper extends ConditionHelper {
    static isValid(condition: PropertyChangeCondition): boolean {
        // TODO - implement
        return true;
    }

    static readonly importMap: ImportMap<PropertyChangeCondition, PropertyChangeConditionData> = [
        { i: "name", o: "name" },
        { i: "condition_id", o: "conditionId" },
        { i: "condition_type", o: "conditionType" },
        { i: "uid", o: "uid" },
        { i: "property", o: "property" },
        { i: "constraint", o: "constraint" },
        { i: "device_class", o: "deviceClass" },
        { i: "comparison_operation", o: "comparisonOperation" },
        { i: "friendlyName", o: "friendlyName" },
    ];

    static fromCHObject(condition): PropertyChangeCondition {
        return {
            name: condition[this.importMap[0].i],
            conditionId: condition[this.importMap[1].i],
            conditionType: condition[this.importMap[2].i],
            controlPointFriendlyName: null,
            uid: condition[this.importMap[3].i],
            property: condition[this.importMap[4].i],
            constraint: condition[this.importMap[5].i],
            controlPointId: null,
            deviceClass: condition[this.importMap[6].i],
            comparisonOperation: condition[this.importMap[7].i],
        };
    }

    static getDefault(): PropertyChangeCondition {
        return {
            name: "Condition Property Change",
            conditionId: null,
            conditionType: ConditionProviders.PROPERTY_CHANGE,
            controlPointFriendlyName: null,
            uid: null,
            serviceName: null,
            property: null,
            constraint: null,
            controlPointId: null,
            deviceClass: null,
            comparisonOperation: null,
        };
    }

    static isEqualTo(cond1: PropertyChangeCondition, cond2: PropertyChangeCondition): boolean {
        {
            let result = false;
            if (
                cond1.comparisonOperation === cond2.comparisonOperation &&
                cond1.deviceClass === cond2.deviceClass &&
                cond1.property === cond2.property &&
                cond1.uid === cond2.uid
            ) {
                result = true;
            }
            return result;
        }
    }

    static extractConstraintValue(constraint) {
        let value = constraint;

        if (Array.isArray(constraint)) {
            value = constraint[0];

            if (constraint[1] === "map") {
                value = JSON.parse(value);
            }
        }

        return value;
    }

    static convertValueToConstraint(value) {
        let _value = value;

        if (!Array.isArray(value)) {
            if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                _value = ["" + value, "string"];
            } else {
                _value = [value, "map"];
            }
        }

        return _value;
    }

    static compareConstraints(constraint1, constraint2) {
        if (Array.isArray(constraint1) && Array.isArray(constraint2)) {
            return constraint1[0] === constraint2[0];
        }

        return constraint1 === constraint2;
    }
}
